// store/modules/client.js

import Vue from "vue";
import ajax from "../../services/ajax";

const state = {
    clientDetails: {},
};

const mutations = {
    SET_CLIENT_DETAILS(state, details) {
        state.clientDetails = details;
        switch (details.client.countrycode.toUpperCase()) {
            case 'BR':
                Vue.i18n.set('br');
                break;
            default:
                Vue.i18n.set('en');
        }
    },
};

const actions = {
    async fetchClientDetails({ commit }) {
        ajax.run(undefined, `customer/details`, (data) => {
            commit('SET_CLIENT_DETAILS', data.ClientDetails.data);
            // Set WHMCS base URL
            ajax.run(this, 'customer/region', (data) => {
                localStorage.setItem('whmcs_base_url', data.region.whmcs_base_url)
            }, (error) => {
                console.log(error)
            })
        }, (error) => {
            console.log(error)
        })
    },
};

const getters = {
    clientDetails: (state) => state.clientDetails,
    error: (state) => state.error,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/modules/client.js